import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/twitter',
    component: () => import('@/views/Twitter/Index.vue'),
    meta: {
      requiresAuth: true,
    }
  },
]

export default routes;